import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["inputLabel", "color", "value", "fieldError", "fieldDisabled", "fieldHelperText", "fieldRequired", "fieldPlaceHolder", "rows", "iconName", "sx"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { ErrorOutlineOutlined } from '@mui/icons-material';
import { FormControl, FormHelperText, InputLabel, OutlinedInput, TAGTypography, TAGSvgIcon } from '../../../';

var TAGTextAreaInput = function TAGTextAreaInput(_ref) {
  var inputLabel = _ref.inputLabel,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$fieldError = _ref.fieldError,
      fieldError = _ref$fieldError === void 0 ? false : _ref$fieldError,
      _ref$fieldDisabled = _ref.fieldDisabled,
      fieldDisabled = _ref$fieldDisabled === void 0 ? false : _ref$fieldDisabled,
      _ref$fieldHelperText = _ref.fieldHelperText,
      fieldHelperText = _ref$fieldHelperText === void 0 ? '' : _ref$fieldHelperText,
      _ref$fieldRequired = _ref.fieldRequired,
      fieldRequired = _ref$fieldRequired === void 0 ? true : _ref$fieldRequired,
      _ref$fieldPlaceHolder = _ref.fieldPlaceHolder,
      fieldPlaceHolder = _ref$fieldPlaceHolder === void 0 ? '' : _ref$fieldPlaceHolder,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 4 : _ref$rows,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? undefined : _ref$iconName,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded);

  var transformedColor = color.includes('.') ? color : "".concat(color, ".main");
  return React.createElement(FormControl, {
    fullWidth: true,
    required: fieldRequired,
    sx: [{
      '& label.Mui-focused': {
        color: fieldError ? 'error.dark' : transformedColor
      },
      // '& label': {
      //   color: fieldDisabled ? ASPENDENTAL_COLOR.text.disabled : labelConditional,
      // },
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          borderColor: transformedColor
        }
      },
      '& .Mui-error': {
        '&.Mui-focused fieldset': {
          borderColor: 'error.dark'
        }
      }
    }, sx]
  }, React.createElement(InputLabel, null, inputLabel), React.createElement(OutlinedInput, _objectSpread(_objectSpread({}, props), {}, {
    value: value,
    // onChange={onChange}
    placeholder: fieldPlaceHolder,
    multiline: true,
    rows: rows,
    sx: {
      py: 2,
      pl: 2,
      pr: 1.5,
      '&.Mui-error': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'error.dark'
        }
      }
    },
    disabled: fieldDisabled,
    error: fieldError,
    label: inputLabel,
    endAdornment: iconName ? fieldError ? React.createElement(ErrorOutlineOutlined, {
      sx: {
        pl: 1.5,
        color: 'error.main'
      }
    }) : React.createElement(TAGSvgIcon, {
      icon: iconName,
      size: 30
    }) : null
  })), React.createElement(FormHelperText, {
    error: fieldError,
    sx: {
      marginLeft: 0,
      '&.Mui-error': {
        color: 'error.dark'
      }
    }
  }, React.createElement(TAGTypography, {
    variant: "lowestLevel"
  }, fieldHelperText)));
};

export default TAGTextAreaInput;